import React from 'react';

export default function MessageModal({ show, onClose, title = "Message", message = "", type = "info" }) {
  if (!show) return null;

  const getColorClasses = () => {
    switch (type) {
      case 'success':
        return 'bg-green-100 text-green-800 border-green-300';
      case 'error':
        return 'bg-red-100 text-red-800 border-red-300';
      case 'warning':
        return 'bg-yellow-100 text-yellow-800 border-yellow-300';
      default:
        return 'bg-blue-100 text-blue-800 border-blue-300';
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-xl shadow-lg w-full max-w-md mx-4 border">
        <div className={`p-4 rounded-t-xl border-b ${getColorClasses()}`}>
          <div className="flex justify-between items-center">
            <h3 className="text-lg font-semibold">{title}</h3>
            <button onClick={onClose} className="text-xl font-bold text-gray-500 hover:text-black">&times;</button>
          </div>
        </div>
        <div className="p-5">
          <p className="text-gray-700">{message}</p>
        </div>
        <div className="flex justify-end px-5 py-3 border-t">
          <button
            onClick={onClose}
            className={`px-4 py-2 rounded font-medium ${type === 'success'
              ? 'bg-green-600 hover:bg-green-700 text-white'
              : type === 'error'
              ? 'bg-red-600 hover:bg-red-700 text-white'
              : type === 'warning'
              ? 'bg-yellow-500 hover:bg-yellow-600 text-white'
              : 'bg-blue-600 hover:bg-blue-700 text-white'}`}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
